// パスのルートを探すために自身のスクリプトのパスから辿る
// なので、このスクリプトまでの位置関係が変わる場合は変更が必要
const CURRENT_SCRIPT_PATH = (() => {
  if (document.currentScript) return document.currentScript.src;
  const scripts = document.getElementsByTagName('script');
  for (let i = 0, l = scripts.length; i < l; i++) {
    const script = scripts[i];
    const src = script.src;
    if (src.match(/\/resources\/js\/dn\.js.*/)) {
      return src;
    }
  }
})();

const ROOT_PATH = CURRENT_SCRIPT_PATH.replace(/\/resources\/js\/dn\.js.*/, '')

const LOCATION_IS_MATCH_BACKUP = !/^\/(dn|dev)\/center/.test(location.pathname);
const LOCATION_IS_MATCH_CMS_VENDOR = /^\/sokuhou\/mondai_k/.test(location.pathname);



/**
 * path join
 */
function pathJoin() {
  return Array.prototype.join.call(arguments, '/').replace(/\/+/g, '/').replace(/(http:|https:)/, '$1/');
}



export default {
  namespaced: true,



  state: {
    root: ROOT_PATH,
    locationIsMatchBackup: LOCATION_IS_MATCH_BACKUP,
    locationIsMatchCmsVendor: LOCATION_IS_MATCH_CMS_VENDOR,
  },



  getters: {
    join: () => (...paths) => pathJoin(...paths),
    $join: (state, getters) => (base, paths) => pathJoin(getters[base], typeof paths === 'string' ? paths : paths.join('/')),
    $resolve: (state, getters, rootState, rootGetters) => href => {
      const matchs = href.match(/\{\{.+?\}\}/g);
      if (!matchs) return href;
      for (let match of matchs) {
        const key = match.match(/\{\{(.+?)\}\}/)[1];
        const myModuleValue = getters[key];
        const val = myModuleValue !== undefined ? myModuleValue : rootGetters['config/' + key];
        if (!key) return 'javascript:void(0);';
        href = href.replace(match, `${val}`);
      }
      return href.replace(/\/+/g, '/').replace(/(http:|https:)/, '$1/');
    },
    root: state => state.root,
    firstDir: state => state.root.match(/\/(((?!\/).)*?)$/)[1],
    resources: state => pathJoin(state.root, 'resources'),
    conf: (state, getters) => pathJoin(getters['resources'], 'conf'),
    locationIsMatchBackup: state => state.locationIsMatchBackup,
    locationIsMatchCmsVendor: state => state.locationIsMatchCmsVendor,

    // 強制的にDNのルートを返却する
    // ※DN内マナビのパスにいる時とかに利用
    dnRoot: (state, getters) => {
      const tmp = getters['root'].split('/');
      tmp[tmp.length - 2] = tmp[tmp.length - 2].replace(/^manabi/, 'dn');
      return tmp.join('/');
    },

    firstDirNameByYear: (state, getters, rootState, rootGetters) => year => {
      return year === rootGetters['config/year'] ? getters['firstDir'] : `dn${year}`;
    },

    // 指定された年度のルートパスを返却する
    // もちろんマナビ側であればマナビ側で返却する
    // 指定年度が最新の場合はcenterで返却する
    yearRoot: (state, getters) => year => {
      const dirName = getters['firstDirNameByYear'](year);
      const anchor = document.createElement('a');
      anchor.href = getters['$join']('root', ['..', dirName]);
      return anchor.href;
    },

    yearedHref: (state, getters) => (year, path) => {
      const dirName = getters['firstDirNameByYear'](year);
      const anchor = document.createElement('a');
      anchor.href = getters['$join']('root', ['..', dirName, path]);
      return anchor.href;
    },

    prevYearedHref: (state, getters, rootState, rootGetters) => path => {
      const year = rootGetters['config/year'] - 1;
      return getters['yearedHref'](year, path);
    },

    switchedDnManabiFullPath: (state, getters, rootState, rootGetters) => {
      return getters[rootGetters['config/isManabi'] ? 'convertedDnFullPath' : 'convertedManabiFullPath']
    },

    convertedManabiFullPath: (state, getters, rootState, rootGetters) => {
      const tmp = rootState.route.fullPath.split('/');
      tmp[1] = tmp[1].replace(/^dn/, 'manabi');
      return tmp.join('/');
    },

    convertedDnFullPath: (state, getters, rootState, rootGetters) => {
      const tmp = rootState.route.fullPath.split('/');
      tmp[1] = tmp[1].replace(/^manabi/, 'dn');
      return tmp.join('/');
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/path.js